import { Clock } from 'lucide-react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';

// Persistent banner shown while a Pro or Custom plan request is awaiting
// Super Admin review. The company keeps Basic-tier access in the
// meantime — this is purely informational, never blocking.
export function ProPendingBanner() {
  const status = useSelector((s) => s.company.plan_request_status);
  if (status !== 'PENDING_PRO_APPROVAL' && status !== 'PENDING_CUSTOM_APPROVAL') return null;

  const isCustom = status === 'PENDING_CUSTOM_APPROVAL';
  return (
    <div className={cn(
      'flex items-center justify-center gap-2 text-[13px] font-medium py-2 px-4 text-center',
      isCustom
        ? 'bg-purple-50 dark:bg-purple-900/20 text-purple-700 dark:text-purple-400 border-b border-purple-200 dark:border-purple-800'
        : 'bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-400 border-b border-amber-200 dark:border-amber-800'
    )}>
      <Clock size={14} className="shrink-0" />
      <span>
        {isCustom
          ? "Your Custom plan request is with our team — we'll call within 1 business hour."
          : "Your Pro upgrade is under review — we'll confirm within 1 business hour."}
      </span>
      <Link to="/settings/plan" className="underline font-semibold whitespace-nowrap">View status</Link>
    </div>
  );
}

export default ProPendingBanner;
